<script>
  import { supabase } from "../auth";
  let menuActive = false;
  import FilledGradientButton from "./FilledGradientButton.svelte";
  import Hamburger from "./Hamburger.svelte";

  function handleLogout() {
    supabase.auth
      .signOut()
      .then((response) => {
        alert("Logout successful");
      })
      .catch((err) => {
        console.log(err);
      });
  }
</script>

<div class="flex">
  <div
    class="md:sticky top-0 px-4 h-screen bg-gray-50 w-80 text-gray-800 {menuActive ===
    true
      ? 'flex fixed'
      : 'hidden bg-opacity-90'} md:flex flex-col justify-between"
  >
    <div class="mx-auto w-72">
      <slot name="sidebar" />
    </div>
    <div class="flex flex-col my-4">
      <h1 class="mx-auto my-4">{supabase.auth.user().email}</h1>
      <FilledGradientButton onClick={handleLogout} text="Logout" />
    </div>
  </div>
  <div class="container w-full mx-auto">
    <nav class="md:hidden">
      <button on:click={() => (menuActive = !menuActive)}>
        <Hamburger active={menuActive} />
      </button>
    </nav>
    <div class="m-4 md:m-2">
      <slot name="content" />
    </div>
  </div>
</div>

<style>
  button:focus {
    outline: 0;
  }
</style>
